import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { AuthService } from '@core/services/auth.service';

/**
 * Allows activation only for authenticated users; otherwise redirects to login.
 * Applied at the main-layout route so every in-app section requires a session,
 * matching the check `requirePermission` already performs on guarded sections.
 */
export const requireAuth: CanActivateFn = (): boolean | UrlTree => {
	const auth = inject(AuthService);
	const router = inject(Router);

	return auth.isAuthenticated() ? true : router.createUrlTree(['/login']);
};
